/** @format */
import { FunctionComponent } from 'react';

import ATFlag from '@toucan/client/global/images/flag-at.svg';
import BEFlag from '@toucan/client/global/images/flag-be.svg';
import DEFlag from '@toucan/client/global/images/flag-de.svg';
import ESFlag from '@toucan/client/global/images/flag-es.svg';
import EUFlag from '@toucan/client/global/images/flag-eu.svg';
import FRFlag from '@toucan/client/global/images/flag-fr.svg';
import IEFlag from '@toucan/client/global/images/flag-ie.svg';
import ITFlag from '@toucan/client/global/images/flag-it.svg';
import NLFlag from '@toucan/client/global/images/flag-nl.svg';
import PTFlag from '@toucan/client/global/images/flag-pt.svg';
import UKFlag from '@toucan/client/global/images/flag-uk.svg';
import USFlag from '@toucan/client/global/images/flag-us.svg';

import { MarketCode } from '@toucan/client/global/market';

export const flags: Record<
    MarketCode,
    FunctionComponent<{ className?: string }>
> = {
    [MarketCode.EN_UK]: UKFlag,
    [MarketCode.EN_US]: USFlag,
    [MarketCode.DE_DE]: DEFlag,
    [MarketCode.FR_FR]: FRFlag,
    [MarketCode.EN_EU]: EUFlag,
    [MarketCode.NL_NL]: NLFlag,
    [MarketCode.IT_IT]: ITFlag,
    [MarketCode.DE_AT]: ATFlag,
    [MarketCode.FR_BE]: BEFlag,
    [MarketCode.NL_BE]: BEFlag,
    [MarketCode.EN_IE]: IEFlag,
    [MarketCode.PT_PT]: PTFlag,
    [MarketCode.ES_ES]: ESFlag,
};
